module.exports = __webpack_public_path__ + "img/jtb-avatar-7565.0c19aa38.jpg";